import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import Config from "../models/Config";
import Species from "./Species";

export default function SpeciesMenu(props) {
  const { showSpecies, setShowSpecies } = props;

  if (showSpecies) {
    return (
      <div className="text-center">
        <div className="text-center mb-8" style={{ minHeight: "40px" }}>
          <button
            onClick={() => setShowSpecies(false)}
            class="rounded-md bg-gray-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-600 active:bg-gray-700"
          >
            <ChevronUpIcon className="h-5 w-5 float-left mr-1"></ChevronUpIcon>{" "}
            Hide
          </button>
        </div>
        {
        Object.keys(Config).map((item, i) => {
          return (<Species type={Config[item]}></Species>);
        })}
      </div>
    );
  } else {
    return (
      <div className="text-center" style={{ minHeight: "40px" }}>
        <button
          onClick={() => setShowSpecies(true)}
          class="rounded-md bg-gray-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-600 active:bg-gray-700"
        >
          <ChevronDownIcon className="h-5 w-5 float-left mr-1"></ChevronDownIcon>{" "}
          Show all species
        </button>
      </div>
    );
  }
}
